<template>
    <div class="ch-container">
        <div class="logo-bar">

            <el-row :gutter="20" type="flex" align="middle">
                <el-col :span="10">
                    <logo-view />
                </el-col>
                <el-col v-if="false" :span="4">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="onSelect">
                        <el-menu-item :index="item.path" v-for="(item, index) in menus" :key="index"
                            @click="item.outerPath ? toOuter(item.outerPath) : ''">
                            {{ item.lable }}
                        </el-menu-item>
                    </el-menu>
                </el-col>
                <el-col :span="14" style="text-align: center;">
                    <div style="display: flex;align-items: center;justify-content: end;">
                        <div>
                            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                                @select="onSelect">
                                <el-menu-item :index="item.path" v-for="(item, index) in menus" :key="index"
                                    @click="item.outerPath ? toOuter(item.outerPath) : ''">
                                    {{ item.lable }}
                                </el-menu-item>
                            </el-menu>
                        </div>
                        <el-dropdown v-if="userInfo">
                            <span class="el-dropdown-link" style="cursor: pointer;width: 200px;">
                                {{ supplierName }}
                                <el-tag size="small" type="primary" style="margin-left: 5px;">{{
                                    dictionaryData[userInfo.supplyType]
                                }}</el-tag>
                                <span v-if="false" style="color: #DE2C15;">
                                    {{ memberStatus == 1 ? "会员" : memberStatus == 2 ? "过期" : "" }}
                                </span>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <!--              <el-dropdown-item >{{userName}}</el-dropdown-item>-->
                                <router-link class="router-link" to="/user/project">
                                    <el-dropdown-item>我的项目</el-dropdown-item>
                                </router-link>
                                <router-link class="router-link" to="/user/info">
                                    <el-dropdown-item>账户信息</el-dropdown-item>
                                </router-link>
                                <el-dropdown-item v-if="false">
                                    <div @click="unLockCa" v-if="userInfo.ifLock">解绑CA</div>
                                    <div @click="lockCa" v-else>绑定CA</div>
                                </el-dropdown-item>
                                <!--              <router-link class="router-link" to="/user/info">-->
                                <!--                <el-dropdown-item>消息中心</el-dropdown-item>-->
                                <!--              </router-link>-->
                                <el-dropdown-item divided>
                                    <div @click="onLogout" style="color:#999999">退出登录</div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button-group v-if="!userInfo">
                            <el-button style="font-size: 18px;" class="loginBox" @click="onLogin">登录</el-button>
                            <el-button style="font-size: 18px;" type="primary" class="loginBox2"
                                @click="onRegister">注册</el-button>
                        </el-button-group>
                    </div>

                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>
import logoView from "../../components/logo";
import login from "@/api/login/login"
import home from "@/api/home/index.js"
import req from "@/api/config/config";
import socketApi from '@/utils/socket.js'

export default {
    created() {
        if (JSON.parse(localStorage.getItem("userInfo"))) {
            this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
            this.userName = JSON.parse(localStorage.getItem("userInfo")).userName;
            this.supplierName = JSON.parse(localStorage.getItem("userInfo")).companyName
            this.memberStatus = JSON.parse(localStorage.getItem("userInfo")).memberStatus
        }
    },
    data() {
        return {
            // 关键字
            keyword: undefined,
            userName: "",
            supplierName: "",
            activeIndex: "",
            userInfo: '',
            dictionaryData: {},

        };
    },
    computed: {
        menus() {
            return this.$store.state.menus.list;
        },
        // activeIndex(){
        //   return this.$store.state.menus.activeIndex;
        // },
    },
    components: {
        logoView,
    },
    mounted() {
        this.activeIndex = this.$route.path
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        this.dictionary()
    },
    methods: {
        dictionary() {
            home.dictionary({ code: 'supplier' }).then(res => {
                this.dictionaryList = res.data
                let resData = {}
                res.data.forEach(element => {
                    resData[element.code] = element.value
                });
                this.dictionaryData = resData
            })
        },
        /**
         * 注册
         */
        onRegister() {
            this.$router.push('/login')
            // sessionStorage.setItem('loginWay', 1)
            // let newBiaoQianYe = this.$router.resolve({
            //     path: '/login',

            // })
            // window.open(newBiaoQianYe.href, '_blank');
            // this.$router.push('/choice')
        },
        /**
         * 登录
         */
        onLogin() {
            // this.$router.push("/login")
            //   sessionStorage.setItem('loginWay', 0)
            //   let newBiaoQianYe = this.$router.resolve({
            //     path: '/choice',

            //   })
            //   window.open(newBiaoQianYe.href, '_blank');
            // window.open('http://manage.jicai.zhishanglianpin.com/#/choice')
            this.$router.push("/choice")
        },
        // 跳转第三方网站
        toOuter(path) {
            // window.location.href = path
            window.open(path)
        },
        onSelect(index) {
            if (index == this.activeIndex) {
                return
            }
            this.$router.push({ path: index });
        },
        onLogout() {
            this.$confirm('此操作将退出系统, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('user/logout');
                localStorage.removeItem("userInfo");
                // sessionStorage.removeItem("Token");
                // localStorage.clear()
                this.$router.replace("/choice");
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });
            });

        },
        // 解绑CA
        unLockCa() {
            this.$confirm('此操作将解绑CA, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                login.unLockCa().then(res => {
                    if (res.code == 0) {
                        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
                        userInfo.ifLock = false;
                        localStorage.setItem("userInfo", JSON.stringify(userInfo));
                        this.$router.go(0)
                        this.$message.success('解绑成功');
                    } else {
                        console.log('res', res);
                        this.$message.error(res);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消解绑CA'
                });
            });

        },
        // 绑定ca
        lockCa() {
            if (!this.$CA.getSignCertInfo()) {
                this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
                return
            }
            let serialNumber = this.$CA.getSignCertInfo();
            login.lockCa({
                caSerialNumber: serialNumber,
            }).then(res => {
                if (res.code == 0) {
                    this.userInfo.ifLock = true;
                    localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
                    this.$message.success(res.message);
                } else {
                    this.$message.error(res.message);
                    // this.$message.error(res);
                }
            })
        },
        // 获取用户信息
        getUserInfo() {
            login.getUserInfo().then(res => {
                if (res.code == 0) {
                    localStorage.setItem("userInfo", JSON.stringify(res.data));
                    // this.$message.success(res.message);
                } else {
                    console.log('res', res);
                    // this.$message.error(res);
                }
            })
        },
    },
    watch: {
        "$route"(to) {
            console.log(to);
            this.activeIndex = to.path
        }
    },
};
</script>

<style lang="less" scoped>
.router-link {
    text-decoration: none;
}

.logo-bar {
    padding: 10px 0;
    color: #9fa5b7;
    font-size: 12px;
}

/deep/ .el-input__inner {
    border-color: #3a84f7 !important;
}

/deep/ .el-input-group__append {
    background-color: #3a84f7 !important;
    border-color: #3a84f7 !important;
    color: #ffffff;
}

/deep/.el-menu.el-menu--horizontal {
    border-bottom: 0;
}

.loginBox,
.loginBox2 {
    border: 0;
    border-radius: 0;
    font-size: 12px;
    width: fit-content;
    padding: 18px;
}

// .el-menu-item{
//   font-size: 16px !important;
// }

/deep/.loginBox2 {
    background-color: #DE2C15;
}

/deep/.loginBox {
    color: #DE2C15;
}

/deep/.el-menu-item {
    height: unset;
    line-height: unset;
    padding: 0;
}

/deep/.el-menu-demo {
    display: flex;
    justify-content: end;

    .el-menu-item {
        font-size: 18px;
        margin-right: 50px;
    }
}

.el-menu::after,
.el-menu::before {
    display: none;
}

.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom-width: 4px;
}

.ch-container {
    width: 95%;
}
</style>